angular.
    module('scheduleApp').
    component('authorization', {  // This name is what AngularJS uses to match to the `<phone-list>` element.
        templateUrl: '../Frontend/CustomersPortal/src/partials/authorization.template.html',
        controller: ['$scope', '$http', '$translate', '$filter', '$timeout', AuthorizationController],
        bindings: {
            login: '<'
        }
});

function AuthorizationController($scope, $http, $translate, $filter, $timeout){
    $scope.Namespace = namespace;
    $scope.GymID = gymid;
    $scope.dashLogin = this.login ? this.login : false;

    if ( isMobile ){
        $scope.mobileApp = isMobile;
    }

    if (gym)
        $scope.gym = gym;

    if (learnedFrom)
        $scope.learnedFrom = learnedFrom

    var $translateThis = $filter('translate');

    $scope.showLogin = function () {
        $scope.dashLogin = true;
    }

    $scope.hideLogin = function () {
        $scope.dashLogin = false;
    }


    // Get Gyms
    getGyms = function () {
        var dataObject = {
            Namespace: namespace
        }

        $http({
            method: 'POST',
            url: '/Membership/GetGyms',
            data: dataObject
        }).success(function (data) {
            $scope.membershipGyms = data;
            
            //$scope.$apply();

            if ($scope.membershipGyms.length == 1) {
                $timeout(function () {
                    $scope.RegGymName = $scope.membershipGyms[0].GymID;
                })
            }
        }).error(function () {
            // console.log('error');
        });
    }

    getGyms();

    $scope.accRegister = function () {
        $scope.loading = true;
        $scope.currentLang = $translate.proposedLanguage() || $translate.use();
        var GymID = gymid;
        var Namespace = namespace;
        var regbirthdate = $('#RegBirthdate').val();
        var res = regbirthdate.split("/");
        var date = res[1] + '/' + res[0] + '/' + res[2];
        var intlNumber = $(".flag-container .selected-dial-code").html() + $('#RegPhone').val();

        if ($scope.gym[0].Culture == 'en-US') {
            date = regbirthdate;
        } else {
            date = date;
        }

        var dataObject = {
            RegEmail: $('#RegEmail').val(),
            RegPassword: $('#RegPassword').val(),
            RegConfirmPassword: $('#RegConfirmPassword').val(),
            RegFirstName: $('#RegFirstName').val(),
            RegLastName: $('#RegLastName').val(),
            Namespace: namespace,
            GymID: gymid,
            Male: $scope.regSexRadio,
            Telephone: intlNumber,
            DivisionID: $('#RegGym').val(),
            Birthdate: date,
            LearnedFrom: $('#RegLearnedFrom').val(),
            WorkAddress: $('#RegWorkAddress').val(),
            RecommendBy: $('#RegRecommendBy').val(),

        }

        $http({
            method: 'POST',
            url: '/account/register/',
            data: dataObject
        }).success(function (data) {
            var data = data;

            if (data == 'Success') {
                var currentHref = window.location;
                var href = currentHref.origin + '/Account/ConfirmYourEmail?nameSpace=' + namespace + '&gymId=' + gymid;
                if ( isMobile == true ) {
                    href += '&isMobile=true';
                }  

                window.location.replace(href);
            } else {
                var n = data.search("com is already taken");

                if (n > 0) {
                    var translated = $translateThis('User Taken');
                    $('.validation-errors').html('<div class="section-valid"><p>' + translated + '</p></div>');
                } else {
                    var res = data.split(".");

                    if (res.length > 2) {
                        $('.validation-errors').html('<div class="section-valid"></div>');
                        for (var i = 0; i < res.length - 1; i++) {
                            var msg = res[i] + '.';
                            var translated = $translateThis(msg);
                            $('.validation-errors .section-valid').append('<p>' + translated + '</p>');
                        }
                    } else {
                        var translated = $translateThis(data);
                        $('.validation-errors').html('<div class="section-valid"><p>' + translated + '</p></div>');
                    }
                }
            }
            $scope.loading = false;

        }).error(function () {
            // console.log('error');
        });
    };

    $scope.accLogin = function () {

        $scope.loading = true;
        var gymid = $('#accGymID').val();
        var namespace = $('#Namespace').val();

        var email = $('#Email').val();
        email = email.replace(/ /g,'');
        var password = $('#Password').val();
        var rememberme = $('#rememberMe').val();

        var dataObject = {
            Email: email,
            Password: password,
            RememberMe: rememberme,
            Namespace: namespace,
            GymID: gymid
        }

        $http({
            method: 'POST',
            url: '/account/login/',
            data: dataObject
        }).success(function (data) {
            var data = data;
            var currentHref = window.location;
            var href = currentHref.origin + '/Account/Dashboard?nameSpace=' + namespace + '&gymId=' + gymid;

            if (data == 'Success') {
                window.location.replace(href);
            } else {
                var translated = $translateThis(data);
                $('.validation-errors').html('<div class="section-valid"><p>' + translated + '</p></div>');
            }
            $scope.loading = false;

        }).error(function () {
            // console.log('error');
        });
    };


    function setCookie(key, value) {
        var val = value;
        var expires = new Date();
        expires.setTime(expires.getTime() + (1 * 24 * 60 * 60 * 1000));
        document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
        if (val != "true") {
            $('body').addClass('pound-currency');
        } else {
            $('body').removeClass('pound-currency');
        }
    }

    function getCookie(key) {
        var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
        return keyValue ? keyValue[2] : null;
    }

    var today = new Date();
    var datepicker = $('#RegBirthdate');
    var lastDate = getCookie('setDate');

    datepicker.datepicker({
        changeMonth: true,
        changeYear: true,
        yearRange: "1920:2040",
        numberOfMonths: 1,
        onSelect: function (dateText, inst) {
            $scope.currentLang = $translate.proposedLanguage() || $translate.use();
            var date = $(this).val();

            if ($scope.gym[0].Culture != 'en-US') {
                var res = date.split("/");
                var date = res[1] + '/' + res[0] + '/' + res[2];
            }
            $scope.cardStartDate = new Date(date);
            $scope.membershipStartDate = $scope.cardStartDate;

            if ($('.section-authorize').length && !$('#RegBirthdayVal').is(':checked')) {
                $('#RegBirthdayVal').trigger('click');
            }
            
            if ( $('.onepage-wrapper').length ) {
                $scope.theChoosenMembershipDate = $scope.cardStartDate;
            }
            $scope.$apply();
        }
    });
    $scope.currentLang = $translate.proposedLanguage() || $translate.use();

    if ($('.section-authorize').length) {
        datepicker.datepicker("option", "maxDate", 0);
    }

    datepicker.next('i').on('click', function () {
        datepicker.datepicker('show');
    });


    if ($scope.currentLang == 'en') {
        datepicker.datepicker("option", $.datepicker.regional['en']);
    }else if ($scope.currentLang == 'es' || $scope.currentLang == 'esc'){
        datepicker.datepicker("option", $.datepicker.regional['es']);
    }else {
        datepicker.datepicker("option", $.datepicker.regional['bg']);
    }

    if ( $scope.gym[0].Culture == 'en-US' ) {
        datepicker.datepicker("option", "dateFormat", 'mm/dd/yy');
    }else{
        datepicker.datepicker("option", "dateFormat", 'dd/mm/yy');
    }

    // $(document).on('click', '.lang-nav li a', function () {
    //     var lang = $(this).data('lang');

    //     if (lang == 'en') {
    //         datepicker.datepicker("option", $.datepicker.regional['en']);
    //     }else if ($scope.currentLang == 'es' || $scope.currentLang == 'esc'){
    //         datepicker.datepicker("option", $.datepicker.regional['es']);
    //     } else {
    //         datepicker.datepicker("option", $.datepicker.regional['bg']);
    //     }

    //     if ( $scope.gym[0].Culture == 'en-US' ) {
    //         datepicker.datepicker("option", "dateFormat", 'mm/dd/yy');
    //     }else{
    //         datepicker.datepicker("option", "dateFormat", 'dd/mm/yy');
    //     }
    // })

    $(window).on('load', function () {

        let phoneLang = $scope.currentLang == 'en' ? 'gb' : $scope.currentLang;
        phoneLang = $scope.currentLang == 'esc' ? 'es' : $scope.currentLang;


        $('#RegPhone').intlTelInput({
            autoHideDialCode: false,
            preferredCountries: [phoneLang],
            separateDialCode: true
        });
    })
}